import { apiClient as client } from './client';

export interface ServiceUsageBreakdown {
    total: number;
    count: number;
    usageValue: number;
    usageType: string;
}

export interface ServiceUsageLog {
    id: string;
    userId: string;
    service: string;
    provider: string;
    amount: number;
    currency: string;
    usageType: string;
    usageValue: number;
    breakdown: string;
    metadata: string;
    createdAt: string;
}

export interface UserUsageResponse {
    user: {
        id: string;
        email: string;
        name: string;
    };
    totalCost: number;
    serviceBreakdown: Record<string, ServiceUsageBreakdown>;
    recentLogs: ServiceUsageLog[];
}

export interface GlobalUsageSummary {
    windowDays: number;
    serviceTotals: {
        service: string;
        total: number;
    }[];
    dailyBreakdown: {
        date: string;
        total: number;
    }[];
    topUsers: {
        userId: string;
        amount: number;
        user: {
            id: string;
            email: string;
            name: string;
        };
    }[];
}

interface ApiResponse<T> {
    success: boolean;
    data: T;
}

const usageApi = {
    getSummary: (days?: number) =>
        client.get<ApiResponse<GlobalUsageSummary>>('/admin/usage/summary', {
            params: days ? { days } : undefined,
        }).then(res => res.data.data),

    getUserUsage: (userId: string, startDate?: string, endDate?: string) =>
        client.get<ApiResponse<UserUsageResponse>>(`/admin/usage/users/${userId}`, {
            params: { startDate, endDate }
        }).then(res => res.data.data)
};

export default usageApi;
